export default "__VITE_ASSET__C0GxO2TC__"